import {
  DoctorMapping,
  ScheduleMapping,
  DoctorBookings,
  ServiceMapping,
  DoctorWithAddress,
  HisDoctorWithUnit,
} from "../api/models";
import { Validation } from "./Validation";
import { SlotLookup } from "./SlotLookup";

class ModelValidator {
  checkDocplannerDoctor(doctor: DoctorWithAddress | undefined): Validation[] {
    if (!doctor) return [];

    if (!doctor.address) {
      return [
        {
          title: "Brak adresu",
          message:
            "Lekarz nie ma przypisanego adresu w ramach jednostki. Uzupełnij konfiguracje po stronie Znanego Lekarza.",
        },
      ];
    }

    if (!doctor.services || doctor.services.length === 0) {
      return [
        {
          title: "Brak usług",
          message:
            "W ramach adresu lekarz nie posiada zdefiniowanych usług. Uzupełnij konfiguracje po stronie Znanego Lekarza.",
        },
      ];
    }

    return [];
  }

  checkHisDoctor(doctor: HisDoctorWithUnit | undefined) {
    let result: Validation[] = [];
    if (!doctor) return result;

    if (!doctor.unit) {
      result.push({
        title: "Brak przypisania do jednostki",
        message:
          "Lekarz nie jest przypisany do jednostki dostępnej dla portalu pacjenta. Uzupełnij konfiguracje po stronie Optimed NXT.",
      });
    }

    return result;
  }

  checkDoctorMapping(doctor: DoctorMapping) {
    let result: Validation[] = [];

    if (!doctor.his) {
      result.push({
        title: "Brak lekarza w Optimed NXT",
        message:
          "Nie znaleziono lekarza w Optimed NXT lub nie zdefiniowano mapowania. Terminy i wizyty nie będą synchronizowane.",
      });
    }

    return result.concat(this.checkHisDoctor(doctor.his)).concat(this.checkDocplannerDoctor(doctor.docplanner));
  }

  checkServiceMapping(service: ServiceMapping) {
    let result: Validation[] = [];

    if (!service.docplanner && !service.docplannerAddressService) {
      result.push({
        title: "Brak mapowania na procedurę w portalu Znany Lekarz",
        message:
          "Nie powiązano tej procedury z jej odpowiednikiem w portalu Znany Lekarz. Przy rezerawcji wizyty na tą procedure w Optimed NXT nie będzie ona widoczna.",
      });
    }

    return result;
  }

  checkScheduleMapping(schedule: ScheduleMapping) {
    let result: Validation[] = [];

    const docplannerSlots = schedule.docplanner?.slots ?? [];
    const docplannerBreaks = schedule.docplanner?.breaks ?? [];
    const hisSlots = schedule.his?.slots ?? [];
    const slotLookup = new SlotLookup(docplannerSlots, hisSlots);

    if (hisSlots.some(x => !slotLookup.existsInDocplanner(x.od))) {
      result.push({
        title: "Brak terminu w portalu Znany Lekarz",
        message: "Nie wszystkie terminy dostępne w Optimed NXT są w tym momencie dostępne w portalu Znany Lekarz.",
      });
    }

    if (docplannerSlots.some(x => !slotLookup.existsInHis(x.start))) {
      result.push({
        title: "Brak terminu w Optimed NXT",
        message: "Nie wszystkie terminy dostępne w portalu Znany Lekarz są teraz dostępne w Optimed NXT.",
      });
    }

    if (docplannerBreaks.length > 0) {
      result.push({
        title: "W portalu Znany Lekarz zdefiniowane są blokady",
        message: "Blokady po stronie Znanego Lekarza nie są synchronizowane i mogą wpływać na dostępność terminów.",
      });
    }

    if (schedule.doctorMapping) {
      result = result.concat(this.checkDoctorMapping(schedule.doctorMapping));
    }

    return result;
  }

  checkBookings(bookings: DoctorBookings) {
    let result: Validation[] = [];

    if (bookings.bookings?.some(x => !x.his && x.docplanner?.status !== "canceled")) {
      result.push({
        title: "Brak wizyty w Optimed NXT",
        message: "Lekarz posiada wizyty które nie są dostępne w Optimed NXT. Spróbuj wymusić synchronizacje danych.",
      });
    }

    if (bookings.doctorMapping) {
      result = result.concat(this.checkDoctorMapping(bookings.doctorMapping));
    }

    return result;
  }
}

export const modelValidator = new ModelValidator();
